import {ScheduledEmailEvent} from "./scheduled-email-event.model";

/**
 * Model reprezentujący zaplanowaną wiadomość e-mail.
 * Służy do zarządzania kolejką wysyłkową (np. newsletterów, przypomnień o wizytach
 * lub powiadomień systemowych).
 */
export class ScheduledEmail {

  /** Tytuł / Temat wiadomości e-mail.
   */
  public title: string;

  /** Data i czas technicznego utworzenia wpisu w kolejce wysyłkowej.
   */
  public created: Date;

  /** Zaplanowana data i czas wysłania wiadomości.
   */
  public scheduledSend: Date;

  /** Lista zdarzeń powiązanych z tym konkretnym mailem.
   * Agreguje pełen cykl życia wiadomości od momentu zaplanowania do ewentualnego otwarcia.
   */
  public scheduledEmailEvents: ScheduledEmailEvent[];
}
